import { IonButton, IonIcon, IonItem, IonList, IonText } from "@ionic/react";
import { checkmarkCircle, chevronDown, chevronUp } from "ionicons/icons";
import { ReactNode, useState } from "react";

function FeatureItems({ items }: { items: readonly string[] }): ReactNode {
  return (
    <IonList className="list" lines="none">
      {items.map((item) => (
        <IonItem key={item}>
          <IonText>{item}</IonText>
          <IonIcon slot="start" icon={checkmarkCircle}></IonIcon>
        </IonItem>
      ))}
    </IonList>
  );
}

function PricingFeatureList({
  extras,
  inherited,
  inheritedFrom,
}: {
  extras: readonly string[];
  inherited: readonly string[];
  inheritedFrom?: string;
}): ReactNode {
  const [expanded, setExpanded] = useState(false);
  const items = expanded ? [...extras, ...inherited] : [...extras];
  const canExpand = inherited.length > 0;

  return (
    <>
      {inheritedFrom && !expanded ? (
        <IonText className="pricing-includes">
          Everything in {inheritedFrom}, plus:
        </IonText>
      ) : null}
      <FeatureItems items={items} />
      {canExpand ? (
        <IonButton
          aria-expanded={expanded}
          className="pricing-toggle"
          data-testid="pricing-show-all-features"
          fill="clear"
          onClick={() => setExpanded((wasExpanded) => !wasExpanded)}
        >
          <IonIcon
            icon={expanded ? chevronUp : chevronDown}
            slot="start"
          ></IonIcon>
          {expanded ? "Show differences" : "Show all features"}
        </IonButton>
      ) : null}
    </>
  );
}

export { FeatureItems, PricingFeatureList };
